export default "__VITE_ASSET__CRI121DU__"